import { render, staticRenderFns } from "./TransactionsWholesalersPaymentsList.vue?vue&type=template&id=0ccba0da&"
import script from "./TransactionsWholesalersPaymentsList.vue?vue&type=script&lang=js&"
export * from "./TransactionsWholesalersPaymentsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports